import React from 'react';
import {observer} from 'mobx-react';
import {Box, Grid} from '@mui/material';
import FormFileField from "../../components/fileUploadComponents/FormFileField";
import AlertNotification from "../../components/notifications/AlertNotification";
import InfoNotification from "../../components/notifications/InfoNotification";

function TaxProfilePanel({feature}) {
    const form = feature.taxProfileForm;
    return (
        <Box p={3}>
            {feature.hasMultipleJurisdictions &&
                <InfoNotification message="Este cliente tiene más de una jurisdicción fiscal registrada."/>
            }
            {feature.hasMultipleJurisdictions && (
                feature.hasCm05Form
                    ? <InfoNotification message="Asegúrese de que el formulario CM05 esté actualizado." />
                    : <AlertNotification message="Este cliente no tiene el formulario CM05 cargado. Por favor, cárguelo." />
            )}
            <Grid container gap={10}>
                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="cm01form"
                        title="Formulario CM01"
                        form={form}
                        fieldName="cm01form"
                        placeholder="Subir archivo..."
                        singleFile
                        readOnly={feature.hasMultipleJurisdictions}
                        onBlur={() => feature.onCm01FormChanged()}
                    />
                </Grid>
                <Grid item xs={10} sm={5}>
                    <FormFileField
                        key="cm05form"
                        title="Formulario CM05"
                        form={form}
                        fieldName="cm05form"
                        placeholder="Subir archivo..."
                        singleFile
                        onBlur={() => feature.onCm05FormChanged()}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}

export default observer(TaxProfilePanel);
